import { ApolloCache } from '@apollo/client';
import {
  CreateDashboardMutation,
  CreateDashboardMutationVariables,
  DashboardViewFragment,
  useCreateDashboardMutation,
} from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';
import { createCachedDashboard } from '../helpers';

interface CreateDashboardOptions {
  shouldSetCache?: boolean;
  onCreate?: (
    dashboard: Pick<DashboardViewFragment, 'id' | 'viewToken'>,
  ) => void;
}

export const useCreateDashboard = ({
  shouldSetCache = true,
  onCreate,
}: CreateDashboardOptions) => {
  const user = useGetUser();

  const [createDashboard, { data, loading, error, called }] =
    useCreateDashboardMutation({
      update: shouldSetCache
        ? (
            cache: ApolloCache<unknown>,
            result: { data?: CreateDashboardMutation | null | undefined },
            options: { variables?: CreateDashboardMutationVariables },
          ) => createCachedDashboard(cache, result, options, user)
        : undefined,
      onCompleted: (data) =>
        data.createDashboard && onCreate?.(data.createDashboard),
    });

  return {
    createDashboard,
    savedDashboard: data?.createDashboard,
    loading,
    error,
    called,
  };
};
